import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { KeyRound, Activity } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const { adoptSession } = useAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/auth/set-password/${token}`).then((r) => setEmail(r.data.email)).catch((e) => setError(errMsg(e))); }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError("Passwords do not match");
    setBusy(true); setError("");
    try { const { data } = await api.post("/auth/set-password", { token, password: pw }); adoptSession(data); navigate("/"); }
    catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <form onSubmit={submit} className="w-full max-w-md space-y-5 rise" data-testid="set-password-form">
        <div className="flex items-center gap-3"><div className="flex h-11 w-11 items-center justify-center rounded-md bg-blue-500 text-white"><Activity size={24} strokeWidth={2.5} /></div><div><div className="font-display text-2xl font-extrabold tracking-tight">Welcome aboard</div><div className="text-xs text-slate-500 uppercase tracking-[0.2em]">Choose your password</div></div></div>
        <div className="pp-card p-6 space-y-4">
          {email && <div className="text-sm text-slate-600">Setting password for <strong data-testid="set-password-email">{email}</strong></div>}
          <div><label className="pp-label block mb-1.5">New password</label><input className="pp-input" type="password" minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="set-password-input" /></div>
          <div><label className="pp-label block mb-1.5">Confirm password</label><input className="pp-input" type="password" minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)} required data-testid="set-password-confirm" /></div>
          {error && <div className="rounded-md border border-rose-500/30 bg-rose-50 px-3 py-2 text-sm text-rose-700" data-testid="set-password-error">{error}</div>}
          <button type="submit" disabled={busy || !email} className="pp-btn-primary w-full" data-testid="set-password-submit"><KeyRound size={16} /> {busy ? "Saving…" : "Set password & sign in"}</button>
        </div>
      </form>
    </div>
  );
}
